export default "__VITE_ASSET__P4I6zyUf__"